import axios from "axios";

const baseApiUrl = process.env["REACT_APP_API_ENDPOINT"];

export const apiClient = axios.create({
  baseURL: baseApiUrl,
  maxRedirects: 0,
  timeout: 60000,
  timeoutErrorMessage:
    "The request take longer than expected. Please try again later.",
  headers: {},
});
